export default __webpack_public_path__ + "static/media/odapi-screenshot.19a570ea.png";